// TSS vite/04 §"Endpoint paths".
// No leading slash — axios joins baseURL + url with a single slash.

export const assignmentPaths = {
    list:    ()   => 'admin/project-teams',
    detail:  (id) => `admin/project-teams/${id}`,
    preview: (id) => `admin/project-teams/${id}/preview`,
    // The two axes. Each one narrows the assignment; an EMPTY axis means no
    // restriction on that axis, which is the opposite of no access.
    repositories: (id)               => `admin/project-teams/${id}/repositories`,
    repository:   (id, repositoryId) => `admin/project-teams/${id}/repositories/${repositoryId}`,
    tiers:        (id)               => `admin/project-teams/${id}/tiers`,
    tier:         (id, tierId)       => `admin/project-teams/${id}/tiers/${tierId}`,
};
